<script setup>
// import { apexDashboard } from '@/data/dashboard/apexChart'
import child_card from '@/pages/dnaReport/component/child_card.vue';
import progress_item from '@/components/progress_item'
import currenAssessmentCard from '@/components/currentAssessmentCard'
import historyCard from '@/components/history_card'
import card_header from '@/components/card_header.vue';
import { get_trait } from '@/services/packages';
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { retrieve_child } from '@/services/child';
import { get_trait_assessment } from '@/services/assessments';
import { swalError } from '@/helper';
import { get_trait_intervention } from '@/services/interventions';


const route = useRoute()
const trait_config = ref()
const isLoading = ref(true)
const child = ref({})
onMounted(async ()=>{
  let response = await get_trait(route.params.trait_id)
  let child_response = await retrieve_child(route.params.child_id)
  await parse_assessment_progress()
  await parse_intervention_progress()
  child.value = child_response.result.data.child.data
  trait_config.value = response.result.data
  parse_progress()
  isLoading.value = false
})

async function parse_intervention_progress(){
  let response = await get_trait_intervention({trait: route.params.trait_id, child: route.params.child_id})
  // console.log("🚀 ~ parse_intervention_progress ~ response:", response)
  if (response.error){
    swalError(response.result.error)
    return
  }
  current_progress.value.intervention = {
    ...response.result.intervention,
    term: response.result.term
  }
  // console.log("🚀 ~ parse_intervention_progress ~ current_progress.value.intervention:", current_progress.value.intervention)
}

const age_group_term = ref({})
const current_progress = ref({assessment: {}, intervention: {}})
async function parse_assessment_progress(){
  let response = await get_trait_assessment({trait: route.params.trait_id, child: route.params.child_id})
  // console.log("🚀 ~ parse_assessment_progress ~ response:", response)
  if (response.error){
    swalError(response.result, true)
    return
  }
  current_progress.value.assessment = {
    ...response.result.assessments, 
    term: response.result.term
  }
  // console.log("🚀 ~ parse_assessment_progress ~ current_progress.value.assessment:", current_progress.value.assessment)
}

function parse_progress(){
  let intervention_progress = []
  let assessment_progress = []
  // console.log("🚀 ~ parse_progress ~  current_progress.value:",  current_progress.value)
  intervention_progress = current_progress.value.intervention?.included?.filter((item)=> item.type == 'intervention_progress')
  assessment_progress = current_progress.value.assessment?.included?.filter((item)=> item.type == 'assessment_progress')
  let combine = assessment_progress.concat(intervention_progress)
  combine = combine.filter(item => item)
  // console.log("🚀 ~ parse_progress ~ combine:", combine)
  let sorted = combine.sort((a,b) =>  parseInt(a.updated_at) - parseInt(b.updated_at))
  current_progress.value.progress = sorted
}
</script>

<template>
  <div class="container-fluid">
    <Breadcrumbs main="Child Report"/>
    
    <loadingCard v-if="isLoading" />
    <div v-else class="row">
      <!-- Child Info -->
      <child_card class="col-md-6" :child="child"/>
      
      <div class="row">
        <!-- Current Progress -->
        <div class="col-8">
            <div class="card">
              <card_header 
                :title="'Current Progress for ' + trait_config.attributes.name " 
                :has_border="true"
                :is_narrow="true"
              >
                <div class="position-absolute end-0 me-2">
                  <div class="chart-card-info me-2">
                    <p class="mb-0">
                      Current Age Group :
                      <span>{{ current_progress.assessment.term.name || '-' }}</span>
                    </p>
                  </div>
                </div>
              </card_header>
              
              <!-- List -->
              <div class="card-body">
                <template v-for="item in current_progress.progress" :key="item.id">
                  <progress_item :item="item" :child="child" />
                </template>
              </div>
            </div>
        </div>
        
        <!-- Current Assessment -->
        <currenAssessmentCard :assessment="current_progress.assessment" />

        <!-- History -->
        <historyCard :child="child" :trait="trait_config" />
      </div>
      
    </div>
  </div>
</template>